import timePeriodList from "./time-period";
import decisionTypesList from "./decision-types";
import countriesList from "./countries";
import singleCountryList from "./single-country";

export default [...timePeriodList, ...decisionTypesList, ...countriesList, ...singleCountryList];
